import { useIntersectionObserver } from 'src/common/hooks/useIntersectionObserver'
import { useAnalytics } from 'src/common/analytics'
import Section from 'src/components/shared/Section'
import Img from 'src/components/shared/Img'

export const onViewH2Id = 'across-america-section'

const AcrossAmericaSection = () => {
  const { track } = useAnalytics()
  const { ref } = useIntersectionObserver({
    threshold: 0.8,
    freezeOnceVisible: true,
    onChange: (isIntersecting) => {
      if (!isIntersecting) return
      track(
        { additional_info: { section: onViewH2Id }, event_type: 'track' },
        {},
        'section_view'
      )
    },
  })

  return (
    <Section>
      <div
        className="flex w-full flex-col items-center gap-8 font-ultramarine text-gray-555"
        data-testid="facts-across-america-content"
      >
        <h2
          ref={ref}
          className="text-center text-heading-3 font-bold leading-[31.2px] text-gray-555 lg:text-left lg:text-heading-2 lg:leading-[41.6px]"
          data-testid="facts-across-america-title"
        >
          Helping debt relief clients across America
        </h2>

        <div data-testid="facts-across-america-map">
          <Img
            src="/next-assets/facts/map.webp"
            alt="Map of the USA highlighting states where Freedom Debt Relief services are available, shown in blue"
            width={746}
            height={483}
            layout="intrinsic"
          />
        </div>

        <div
          className="flex items-center justify-start gap-3 lg:justify-center"
          data-testid="facts-across-america-legend"
        >
          <div className="h-[19px] w-[9px] rounded-[3px] bg-blue-585 lg:h-7 lg:w-[11px]" />
          <span className="text-14 leading-[19.6px] lg:text-body-medium lg:leading-[22.4px]">
            Freedom Debt Relief availability{' '}
          </span>
        </div>

        <div
          className="flex max-w-[642px] flex-col gap-6 text-12 leading-[16.8px] text-neutral-300"
          data-testid="facts-across-america-availability"
        >
          <p className="text-center lg:text-left">
            Freedom Debt Relief is available in AL, AK, AR, AZ, CA, DE, FL, IA,
            ID, IN, KY, LA, MA, MD, MI, MN, MO, MS, MT, NC, NE, NM, NV, NY, OK.,
            PA, SD, TN, TX, UT.
          </p>
          <p className="text-center lg:text-left">
            Freedom Debt Relief works with legal partners to provide debt
            settlement services in: CT, GA, NH, NJ, IL, KS, ME, OH, SC, VA.
          </p>
        </div>
      </div>
    </Section>
  )
}

export default AcrossAmericaSection
